export default {
  install: function(Vue, opts = {}) {
    /*
    const _this = this

    const self = new Vue(_this)

    Object.defineProperty(Vue.prototype, '$auth', {
      get () {
        return self
      }
    })*/

    const { router } = opts;

    if (!router) {
      console.info(
        "To use with vue-router, pass it to me Vue.use(VueAuth, {router})"
      );
    } else {
      
      router.beforeEach(async (to, from, next) => {
        //console.log("beforeEach", { to, from, next });

        try {
          if (to.name === "supportSession") {
            next();
            return;
          }

          const supportToken = sessionStorage.getItem("SupportAuthorization");
          const isSupportWindow = sessionStorage.getItem("SupportWindow") === "1";
          const token = supportToken || (isSupportWindow ? null : localStorage.getItem("Authorization"));
         
          if (!token) {
             
            if (
              to.name == "login" ||
              to.name == "resetPassword" ||
              to.name == "resetPasswordConfirm" ||
              to.name == "signUp" ||
              to.name == "accountActivation" ||
              to.name == "Dsgvo"
            ) {
              next();
            } else {
              next({ name: "login" });
            }
          } else {
            const store = opts.store;

            //if (!store.state.auth.mySelf) {
            await store.dispatch("auth/getMySelf");

            
            if (!store.state.auth.mySelf) {
              if (sessionStorage.getItem("SupportAuthorization")) {
                sessionStorage.removeItem("SupportAuthorization");
              } else {
                localStorage.removeItem("Authorization");
              }
              next({ name: "login" });
              //throw new Error("Incorrect token");
            } else if (
              to.matched.some(record => record.meta && record.meta.adminOnly) &&
              !store.state.auth.mySelf.roles.includes("admin")
            ) {
              next({ name: "home" });
              return;
            }
            //}

            if (
              to.name == "login" ||
              to.name == "resetPassword" ||
              to.name == "resetPasswordConfirm" ||
              to.name == "signUp" ||
              to.name == "Dsgvo"
            ) {
              console.log("next to home")
              next({ name: "home" });
            } else {
              next();
            }
          }
        } catch (e) {
          console.log("e", e);

          if (
            to.name == "login" ||
            to.name == "resetPassword" ||
            to.name == "resetPasswordConfirm" ||
            to.name == "signUp" ||
            to.name == "accountActivation" ||
            to.name == "Dsgvo"
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        }
      });
    }
  }
};
